/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import SendApplication from "./SendApplication";
import { Helmet } from "react-helmet-async";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import { attorneyDosAndDonts } from "@/src/services/jobs/jobsService";
import { Box } from "@mui/material";
import DoAndDont from "./DoAndDont";
import AreYouInterestedSection from "./AreYouInterestedSection";
import { gaSet } from "@/src/services/googleAnalyticsService";
import JobContainer, { JobContainerProps } from "@/src/components/Jobs/Job/JobContainer";
import jobStyles from "@/src/components/Jobs/Job/jobStyles";

const attorneyJobDetails: JobContainerProps = {
  title: "Rechtsanwältin / Rechtsanwalt (m/w/d)",
  hardFacts: [
    {
      title: "Standort",
      value: "Köln, DE",
    },
    {
      title: "Beschäftigungsart",
      value: "Vollzeit",
    },
    {
      title: "Arbeitsmodell",
      value: "Hybrid",
    },
    {
      title: "Bereich",
      value: "Legal",
    },
  ],
  content: [
    {
      type: "headline",
      headline: "Du bist (angehender) Rechtsanwalt (w/d/m)? Warum eine Legal-Tech-Kanzlei dein nächster Karriereschritt sein sollte!",
    },
    {
      type: "text",
      text:
        "Du hast dich lange auf deine berufliche Zukunft vorbereitet und möchtest einen Job, der dich von Anfang an begeistert? Dir gefällt die Tätigkeit als " +
        "Anwalt, aber du willst nicht 60 Stunden die Woche arbeiten? Du bist es leid, vom obligatorischen Obstkorb und halbjährlich stattfindenden " +
        "Kanzleifeiern für einen Job “überzeugt” zu werden?",
    },
    {
      type: "text",
      text: "Komm zu uns und starte deine Karriere in einer Legal-Tech-Kanzlei im Verbraucherrecht!",
    },
    {
      type: "text",
      text:
        "Das Verbraucherrecht ist ein spannendes und schnelllebiges Rechtsgebiet, das in den letzten Jahren immer mehr an Bedeutung gewonnen hat. Es umfasst " +
        "alle Rechtsfragen, die sich aus der Beziehung zwischen Verbrauchern und Unternehmen ergeben. Als Anwalt im Verbraucherrecht arbeitest du mit einer " +
        "Vielzahl von Fällen und Mandanten und kannst bei wiederkehrenden Problemen größere Strategien entwickeln!",
    },
    {
      type: "text",
      text:
        "Eine Legal-Tech-Kanzlei bietet viele Vorteile. Vor allem wirst du Teil eines engagierten Teams von Anwälten sein, die alle dasselbe Ziel verfolgen: " +
        "Verbrauchern zu ihrem Recht zu verhelfen. Durch unsere fortgeschrittene Automatisierung ist es uns möglich, eine Vielzahl von Mandanten zu " +
        "unterstützen. In unserem motivierenden Kanzleiumfeld lernst du von Anfang an, deine Mandate selbstständig zu bearbeiten und Verantwortung zu " +
        "übernehmen.",
    },
    {
      type: "text",
      text: "Lerne Legalbird kennen und sei dabei, wenn wir nicht nur den Rechtsmarkt, sondern auch die Arbeitsbedingungen für Rechtsanwälte revolutionieren!",
    },
    {
      type: "headline",
      headline: "DOs and DON'Ts - Was uns bei Legalbird von klassischen Kanzleien unterscheidet",
    },
  ],
  afterContent: (
    <>
      {attorneyDosAndDonts.map((attorneyDoAndDont) => (
        <Box sx={jobStyles.text}>
          <DoAndDont
            doHeadline={attorneyDoAndDont.doHeadline}
            doText={attorneyDoAndDont.doText}
            dontHeadline={attorneyDoAndDont.dontHeadline}
            dontText={attorneyDoAndDont.dontText}
          />
        </Box>
      ))}
      <AreYouInterestedSection role={"Rechtsanwalt"} />
      <SendApplication />
    </>
  ),
};

const Attorney = () => {
  const title = "Jobs - Rechtsanwältin/Rechtsanwalt | Legalbird";

  gaSet({ title: title });

  return (
    <LayoutPublicRoutes>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <JobContainer {...attorneyJobDetails} />
    </LayoutPublicRoutes>
  );
};

export default Attorney;
